// @flow

import React, { memo } from 'react'

import { useFocusable } from '@alphaott/smart-tv-spatial-navigation'

import {
  ChannelCardTitleBox,
  ChannelCardTitle,
  ChannelCardContainer,
  LeftContainer,
} from './ChannelCategoryCard.style'

type ChannelCategoryCardProps = {
  focusKey?: string,
  heading: string,
  style?: any,
  onFocus?: Function,
  onPress: Function,
  onArrowPress?: Function,
}

const ChannelCategoryCardPure = ({
  focusKey,
  heading,
  style,
  onFocus,
  onPress,
  onArrowPress,
}: ChannelCategoryCardProps) => {
  const { ref, focused } = useFocusable({
    focusKey,
    onFocus,
    onEnterPress: onPress,
    onArrowPress,
  })

  return (
    <ChannelCardContainer ref={ref} style={style} focused={focused} onClick={onPress}>
      <LeftContainer>
        <ChannelCardTitleBox>
          <ChannelCardTitle>{heading}</ChannelCardTitle>
        </ChannelCardTitleBox>
      </LeftContainer>
    </ChannelCardContainer>
  )
}

export const ChannelCategoryCard = memo<ChannelCategoryCardProps>(ChannelCategoryCardPure)

export default ChannelCategoryCard
